// D04 chat.connectionAction.earlierReplyNote: DES1 direction and DES2 reviewed copy.
// Select exact count === 1, not CLDR categories; the count is not displayed.
import type { NamespaceCatalog } from '@/i18n/ns';

const copy = {
  en: {
    earlierReplyNoteOne: 'Written while waiting for your approval. The current result is above.',
    earlierReplyNoteOther:
      'Written while waiting for your approval. The current results are above.',
  },
  sv: {
    earlierReplyNoteOne:
      'Skrevs medan vi väntade på ditt godkännande. Det aktuella resultatet visas ovan.',
    earlierReplyNoteOther:
      'Skrevs medan vi väntade på ditt godkännande. De aktuella resultaten visas ovan.',
  },
  da: {
    earlierReplyNoteOne:
      'Skrevet, mens vi ventede på din godkendelse. Det aktuelle resultat står ovenfor.',
    earlierReplyNoteOther:
      'Skrevet, mens vi ventede på din godkendelse. De aktuelle resultater står ovenfor.',
  },
  de: {
    earlierReplyNoteOne:
      'Verfasst, während auf Ihre Freigabe gewartet wurde. Das aktuelle Ergebnis steht oben.',
    earlierReplyNoteOther:
      'Verfasst, während auf Ihre Freigabe gewartet wurde. Die aktuellen Ergebnisse stehen oben.',
  },
  fr: {
    earlierReplyNoteOne:
      'Rédigé en attendant votre approbation. Le résultat actuel figure ci-dessus.',
    earlierReplyNoteOther:
      'Rédigé en attendant votre approbation. Les résultats actuels figurent ci-dessus.',
  },
  es: {
    earlierReplyNoteOne:
      'Escrito mientras se esperaba tu aprobación. El resultado actual está arriba.',
    earlierReplyNoteOther:
      'Escrito mientras se esperaba tu aprobación. Los resultados actuales están arriba.',
  },
  it: {
    earlierReplyNoteOne:
      'Scritto in attesa della tua approvazione. Il risultato attuale è qui sopra.',
    earlierReplyNoteOther:
      'Scritto in attesa della tua approvazione. I risultati attuali sono qui sopra.',
  },
  pt: {
    earlierReplyNoteOne:
      'Escrito enquanto aguardava a sua aprovação. O resultado atual está acima.',
    earlierReplyNoteOther:
      'Escrito enquanto aguardava a sua aprovação. Os resultados atuais estão acima.',
  },
  nl: {
    earlierReplyNoteOne:
      'Geschreven terwijl op je goedkeuring werd gewacht. Het huidige resultaat staat hierboven.',
    earlierReplyNoteOther:
      'Geschreven terwijl op je goedkeuring werd gewacht. De huidige resultaten staan hierboven.',
  },
  fi: {
    earlierReplyNoteOne: 'Kirjoitettu hyväksyntääsi odottaessa. Nykyinen tulos on yllä.',
    earlierReplyNoteOther: 'Kirjoitettu hyväksyntääsi odottaessa. Nykyiset tulokset ovat yllä.',
  },
  et: {
    earlierReplyNoteOne: 'Kirjutatud sinu kinnitust oodates. Praegune tulemus on üleval.',
    earlierReplyNoteOther: 'Kirjutatud sinu kinnitust oodates. Praegused tulemused on üleval.',
  },
  bg: {
    earlierReplyNoteOne:
      'Написано, докато се чакаше вашето одобрение. Текущият резултат е по-горе.',
    earlierReplyNoteOther:
      'Написано, докато се чакаше вашето одобрение. Текущите резултати са по-горе.',
  },
  cs: {
    earlierReplyNoteOne: 'Napsáno během čekání na vaše schválení. Aktuální výsledek je výše.',
    earlierReplyNoteOther: 'Napsáno během čekání na vaše schválení. Aktuální výsledky jsou výše.',
  },
  sk: {
    earlierReplyNoteOne: 'Napísané počas čakania na vaše schválenie. Aktuálny výsledok je vyššie.',
    earlierReplyNoteOther:
      'Napísané počas čakania na vaše schválenie. Aktuálne výsledky sú vyššie.',
  },
  pl: {
    earlierReplyNoteOne:
      'Napisano podczas oczekiwania na Twoje zatwierdzenie. Aktualny wynik jest powyżej.',
    earlierReplyNoteOther:
      'Napisano podczas oczekiwania na Twoje zatwierdzenie. Aktualne wyniki są powyżej.',
  },
  hr: {
    earlierReplyNoteOne:
      'Napisano dok se čekalo vaše odobrenje. Trenutačni rezultat nalazi se iznad.',
    earlierReplyNoteOther:
      'Napisano dok se čekalo vaše odobrenje. Trenutačni rezultati nalaze se iznad.',
  },
  sl: {
    earlierReplyNoteOne: 'Napisano med čakanjem na vašo odobritev. Trenutni rezultat je zgoraj.',
    earlierReplyNoteOther: 'Napisano med čakanjem na vašo odobritev. Trenutni rezultati so zgoraj.',
  },
  hu: {
    earlierReplyNoteOne: 'Az Ön jóváhagyására várva íródott. Az aktuális eredmény fent látható.',
    earlierReplyNoteOther:
      'Az Ön jóváhagyására várva íródott. Az aktuális eredmények fent láthatók.',
  },
  el: {
    earlierReplyNoteOne:
      'Γράφτηκε ενώ περιμέναμε την έγκρισή σας. Το τρέχον αποτέλεσμα είναι παραπάνω.',
    earlierReplyNoteOther:
      'Γράφτηκε ενώ περιμέναμε την έγκρισή σας. Τα τρέχοντα αποτελέσματα είναι παραπάνω.',
  },
  ro: {
    earlierReplyNoteOne:
      'Scris în timp ce se aștepta aprobarea ta. Rezultatul actual este mai sus.',
    earlierReplyNoteOther:
      'Scris în timp ce se aștepta aprobarea ta. Rezultatele actuale sunt mai sus.',
  },
  lt: {
    earlierReplyNoteOne:
      'Parašyta laukiant jūsų patvirtinimo. Dabartinis rezultatas pateiktas aukščiau.',
    earlierReplyNoteOther:
      'Parašyta laukiant jūsų patvirtinimo. Dabartiniai rezultatai pateikti aukščiau.',
  },
  lv: {
    earlierReplyNoteOne:
      'Uzrakstīts, gaidot jūsu apstiprinājumu. Pašreizējais rezultāts ir redzams augstāk.',
    earlierReplyNoteOther:
      'Uzrakstīts, gaidot jūsu apstiprinājumu. Pašreizējie rezultāti ir redzami augstāk.',
  },
  ga: {
    earlierReplyNoteOne:
      'Scríofa fad is a bhíothas ag fanacht ar do cheadú. Tá an toradh reatha thuas.',
    earlierReplyNoteOther:
      'Scríofa fad is a bhíothas ag fanacht ar do cheadú. Tá na torthaí reatha thuas.',
  },
  mt: {
    earlierReplyNoteOne:
      'Miktub waqt li konna qed nistennew l-approvazzjoni tiegħek. Ir-riżultat attwali jinsab hawn fuq.',
    earlierReplyNoteOther:
      'Miktub waqt li konna qed nistennew l-approvazzjoni tiegħek. Ir-riżultati attwali jinsabu hawn fuq.',
  },
} satisfies NamespaceCatalog<'earlierReplyNoteOne' | 'earlierReplyNoteOther'>;

export default copy;
